<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{modalTitle}} </div>
        <div class="modal-body">
          <ng-container *ngIf="loading">
            <div class="loading-txt">Veuillez patienter ...</div>
            <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          </ng-container>
          <ng-containet *ngIf="erreur">
            <div class="erreur-title">Une erreur est survenue</div>
            <div class="erreur-content" [innerHTML]="erreur"></div>
            <frg-button (activated)="retry()" backgroundColor="var(--danger)">Reesayer</frg-button>
            <frg-button (activated)="closeAfterError()" backgroundColor="var(--darkest-primary)">Fermer</frg-button>
          </ng-containet>
        </div>
    </div>
</div>
<div class="modal-background"></div>
